import { defineLocalePackage } from 'paraguas';
import { recipes } from './recipes';
export const i18nPackage = defineLocalePackage({
    languages: [
        'en',
        'es'
    ],
    recipes
});
export const localeSet = i18nPackage.localeSet;
export const SUPPORTED_LOCALES = localeSet.SUPPORTED_LOCALES;
export const DEFAULT_LOCALE = localeSet.DEFAULT_LOCALE;
export const isSupportedLocale = localeSet.isSupportedLocale;
